import React, {FC} from "react";
import FlexBox from "view/components/Layout/FlexBox";
import {Box} from "@material-ui/core";
import clsx from "clsx";
import useStyles from "./styles";
import {Colors} from "../../constants";

type ColorPickerProps = {
  penColor: string;
  setPenColor: (color: string) => void;
};

type ColorOption = {
  color: string;
  colorStyleKey: keyof ReturnType<typeof useStyles>;
};
const colors: ColorOption[] = [
  {color: Colors.Black, colorStyleKey: "colorBlack"},
  {color: Colors.DarkBlue, colorStyleKey: "colorDarkBlue"},
  {color: Colors.Blue, colorStyleKey: "colorBlue"},
];

const ColorPicker: FC<ColorPickerProps> = ({penColor, setPenColor}) => {
  const classes = useStyles();

  return (
    <FlexBox
      justifyCenter={false}
      justifyContent="flex-end"
      style={{marginBottom: "16px"}}
    >
      {colors.map(({color, colorStyleKey}) => (
        <Box
          key={color}
          role="button"
          tabIndex={0}
          className={clsx(
            classes.colorOption,
            penColor === color && classes.selected,
            classes[colorStyleKey]
          )}
          onClick={() => setPenColor(color)}
          onKeyDown={(event) => {
            if (["Enter", " "].includes(event.key)) {
              setPenColor(color);
            }
          }}
        />
      ))}
    </FlexBox>
  );
};

export default ColorPicker;
